import type { MutationUpdaterFn } from '@apollo/client';

import type * as Schema from 'src/types/graphql';

export const updateCacheUpdateCareerObjectives: MutationUpdaterFn<
  Schema.UpdateCareerObjectivesMutation
> = (cache, { data }) => {
  const _id = data?.updateCareerObjectives?.viewer?._id;
  const personalStatement =
    data?.updateCareerObjectives?.viewer?.careerObjectives?.personalStatement;

  cache.modify({
    id: cache.identify({
      __typename: 'Candidate',
      _id,
    }),
    fields: {
      careerObjectives: () =>
        personalStatement ? { personalStatement } : null,
    },
  });
};

export const generateCareerObjectivesOptimisticResponse =
  (_id: string) =>
  ({
    careerObjectivesData,
  }: {
    careerObjectivesData: Schema.UpdateCareerObjectivesInput;
  }) => ({
    __typename: 'Mutation',
    updateCareerObjectives: {
      __typename: 'UpdateCareerObjectivesPayload',
      viewer: {
        __typename: 'Candidate',
        _id,
        careerObjectives: {
          __typename: 'CareerObjectives',
          personalStatement: careerObjectivesData.personalStatement,
        },
      },
    },
  });
